import {
  StyledOrgDetails,
  StyledOrgDetailsImage,
  StyledOrgDetailsImageIcon,
  StyledOrgDetailsName,
} from './OrgDetails.style';
import SelectedOrg from '../../../../images/icons/selected-org.svg';
import NotSelectedOrg from '../../../../images/icons/unselected-org.svg';
import CheckArea from './CheckArea';

const selectedOrgIconMap = {
  [true]: SelectedOrg, // 'static/media/src/images/icons/selected-org.svg',
  [false]: NotSelectedOrg, // 'static/media/src/images/icons/unselected-org.svg'
};

const OrgDetails = ({
  imageUrl = null,
  orgName,
  isSelected = true,
  showCheck = false,
  onOrgSelected,
}) => {
  return (
    <StyledOrgDetails
      className='org-details'
      onClick={onOrgSelected}
      data-testid='org-details'
    >
      {showCheck && <CheckArea isCheck={isSelected} />}
      <StyledOrgDetailsImage>
        <StyledOrgDetailsImageIcon
          src={imageUrl || selectedOrgIconMap[isSelected]}
        ></StyledOrgDetailsImageIcon>
      </StyledOrgDetailsImage>
      <StyledOrgDetailsName>{orgName}</StyledOrgDetailsName>
    </StyledOrgDetails>
  );
};

export default OrgDetails;
